export const SWITCH_DEVICE = 'SWITCH_DEVICE';
export const SET_DEBUG_MODE = 'SET_DEBUG_MODE';
export const INTL_UPDATE = '@@intl/UPDATE';
